"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicLayoutEffect = void 0;
var react_1 = require("react");
var ssr_1 = require("@r1-frontend/shared/helpers/ssr");
exports.useIsomorphicLayoutEffect = (0, ssr_1.isClientSide)() ? react_1.useLayoutEffect : react_1.useEffect;
